export default __webpack_public_path__ + "static/media/layer3.7c2ab75e.png";